/**
 * Run `fn` over `items` in fixed-size chunks with bounded concurrency,
 * returning one result per chunk in input order.
 */
export async function inChunks<T, R>(
  items: T[],
  size: number,
  fn: (chunk: T[]) => Promise<R>,
  concurrency = 4,
): Promise<R[]> {
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) chunks.push(items.slice(i, i + size));
  const results: R[] = new Array(chunks.length);
  let next = 0;
  const worker = async () => {
    while (next < chunks.length) {
      const index = next++;
      results[index] = await fn(chunks[index]);
    }
  };
  await Promise.all(Array.from({ length: Math.min(concurrency, chunks.length) }, worker));
  return results;
}
